module.exports = __webpack_public_path__ + "static/media/feedback-success.c87596a8.png";